// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Chip, ChipProps, Tooltip } from '@mui/material';

// utils
import { formatCurrency } from '../../../utils/currency';
import { formatPercentage } from '../../../utils/format';

// props
export interface ChipReimbursementProps {
	amountApplied: number;
	amountTotal: number;
	currency: string;
	hasTooltip?: boolean;
}

export const ChipReimbursement = ({
	amountApplied,
	amountTotal,
	currency,
	hasTooltip = true,
}: ChipReimbursementProps) => {
	// hooks
	const { t } = useTranslation();

	// calculate percentage
	const percentApplied = amountTotal > 0 ? (amountApplied / amountTotal) * 100 : 0;

	// determine color based percentage
	let color: ChipProps['color'] = 'default';

	if (amountTotal > 0) {
		if (percentApplied > 100) {
			color = 'error';
		} else if (percentApplied >= 75) {
			color = 'success';
		} else if (percentApplied >= 50) {
			color = 'primary';
		} else if (percentApplied >= 25) {
			color = 'warning';
		} else {
			color = 'error';
		}
	}

	const chip = (
		<Chip color={color} label={formatPercentage(percentApplied)} size="small" variant="twoTone" />
	);

	if (hasTooltip) {
		return (
			<Tooltip
				placement="top"
				title={t('xOfY', {
					x: formatCurrency({ currency, value: amountApplied }),
					y: formatCurrency({ currency, value: amountTotal }),
				})}>
				{chip}
			</Tooltip>
		);
	}

	return chip;
};
